import { useCallback } from "react";

import { Client } from "@/Common/Api/Client";
import { ExternalCommunicationApiSearchPatientContactResponse } from "@/Common/Api/ExternalCommunications/Dto/ExternalCommunicationApiSearchPatientContactResponse";
import { TransferablePatientInfoResponse } from "@/Common/Api/ExternalCommunications/Dto/TransferablePatientInfoResponse";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import * as ServerOperations from "@/Common/Operations/operations.server";
// eslint-disable-next-line import/no-restricted-paths
import { PatientsFoundResult } from "@/Patient/Components/Xcom/PatientsFoundResult";

import styles from "./PatientInfoDialog.module.scss";

interface IPatientInfoDialogProps {
    onClose: () => void;
    clientTag: string;
    patientContactId: string;
}

function PatientInfoDialog(props: Readonly<IPatientInfoDialogProps>): JSX.Element {
    const [patientsFound, setPatientsFound] = React.useState<TransferablePatientInfoResponse[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [selectedPatient, setSelectedPatient] = React.useState<TransferablePatientInfoResponse>(null);

    const footer = React.useMemo(() => (
        <div className="display-flex-justified-end">
            <div className="margin-xs-left">
                <ButtonControl
                    className="btn btn-default"
                    onClick={() => props.onClose()}
                    label={cacheStore.GetString("CancelLabel")}
                />
            </div>
        </div>
    ), [props]);

    const updatePatientsFound = useCallback(async () => {
        const request = {
            PatientContactId: props.patientContactId,
            ClientTag: props.clientTag
        };

        const response = await Client.postAsync<ExternalCommunicationApiSearchPatientContactResponse>(ServerOperations.Server.Myle_ExternalCommunication_SearchPatient, request);
        if (response.isSuccess && response.data) {
            setPatientsFound(response.data.Patients);
            setSelectedPatient(response.data.Patients?.firstOrDefault());
        }
        setIsLoading(false);
    }, [props.clientTag, props.patientContactId]);

    React.useEffect(() => {
        updatePatientsFound();
    }, [props, updatePatientsFound]);
    return (
        <Modal
            showOverlay
            fixedOverlayPosition
            showX
            centerContent
            width={600}
            title={cacheStore.GetString("PatientInformationLabel")}
            onClose={props.onClose}
            footer={footer}
            disableOverlayClose={true}
        >
            <div className={styles.body}>
                <PatientsFoundResult
                    isLoading={isLoading}
                    patients={patientsFound}
                    selectedPatient={selectedPatient}
                    onPatientSelected={p => setSelectedPatient(p)}
                />
            </div>
        </Modal>
    );
}

export { PatientInfoDialog };
